export default (palette, isDarkMode) => ({
  root: {
    color: palette.icon,
    '&:hover': {
      backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
    },
  },
})
